export const paginglist = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
];

export const paginglistDefault = [{ label: "10", value: 10 }];

export const applicationEnum = "admin";

export const statusList = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
]

export const managerLead = 1;

export const supervisorLead = 2;

export const masterDataListEnum = Object.freeze({
  MAINROLE: 'Main role',
  SUPPORTINGROLE: 'Supporting role'
});